export const SITE = {
  appName: process.env.REACT_APP_APP_NAME,
  companyName: process.env.REACT_APP_COMPANY_NAME,
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL,
  contactEmail: process.env.REACT_APP_CONTACT_EMAIL,
  legalAddress: process.env.REACT_APP_LEGAL_ADDRESS,
  policyEffectiveDate: process.env.REACT_APP_POLICY_EFFECTIVE_DATE,
  appStoreUrl: process.env.REACT_APP_APP_STORE_URL,
  googlePlayUrl: process.env.REACT_APP_GOOGLE_PLAY_URL,
  logoDark: "/brand/humn-wordmark.png",
  logoLight: "/brand/humn-wordmark.png",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
